/**
 * 项目入口
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
import _ from "lodash";
import { get, getSafe, post, postSafe, postJson, download } from "@/util/http";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import "@/util/dialogDrag";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import { bizFolderName, apiAuth } from "./bizConfig";
import localCache from "@/util/localCache";
import "element-ui/lib/theme-chalk/icon.css"; //element-ui 图标库
import '@/views/common_module/common/comp/compTable/index'
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/index.css";
import echarts from "echarts";
import ECharts from 'vue-echarts'
import "./util/rem.js";
import HighchartsVue from "highcharts-vue";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import 'highlight.js/styles/atom-one-light.css';
Vue.use(codemirror);
Vue.config.productionTip = false;
import "element-ui/lib/theme-chalk/index.css";
import "@/views/common_module/assets/base/style/login.scss";
import "@/views/common_module/assets/base/userIcon/iconfont.css";
import '@/views/common_module/assets/base/AllIconFont/iconfont.css'
import "@/assets/iconfont/iconfont.css";

Vue.use(VXETable);
Vue.prototype.$echarts = echarts;
Vue.use(HighchartsVue);
//全局删除增加图标

// Vue.use(eIconPicker, {
//   FontAwesome: true,
//   ElementUI: true,
//   eIcon: true,
//   eIconSymbol: true
// });
// Vue.use(EIcon);
// Vue.use(iconPicker);
// iconList.addIcon(EIcon);
import '@/views/aiAgent/util/confirmDialog';
import Ripple from '@/views/aiAgent/directives/v-ripple';
Vue.directive('ripple', Ripple);
import '@/views/aiAgent/util/popMessage';
import VueUeditorWrap from "vue-ueditor-wrap";
Vue.component("vue-ueditor-wrap", VueUeditorWrap);
Vue.component('v-chart', ECharts);
Vue.config.productionTip = false;
Vue.use(VueI18n); // 通过插件的形式挂载
Vue.use(localCache);
// Vue.use(HighchartsVue)
/** 全局挂载API请求方法集合对象, 包含post, get等等http请求方法对象 */
Vue.prototype.$http = {
  get,
  getSafe,
  post,
  postSafe,
  postJson,
  download
};
/** 全局挂载lodash工具 */
Vue.prototype._ = _;

/** 全局挂载API鉴权方法apiAuth */
Vue.prototype.apiAuth = apiAuth;

/**
 * 国际化配置
 */
export const messages = {
  en: {
    // 英文语言包
    // 公用的国际化语言, 以c.开头
    ...require("@/views/common_module/base/lang/en"),
    // 业务应用的国际化语言, 以m.开头
    ...require("@/views/common_module/" + bizFolderName + "/lang/en"),
    // ElementUI的国际化语言, 以el.开头
    ...enLocale
  },
  zh: {
    // 中文语言包
    // 公用的国际化语言, 以c.开头
    ...require("@/views/common_module/base/lang/zh"),
    // 业务应用的国际化语言, 以m.开头
    ...require("@/views/common_module/" + bizFolderName + "/lang/zh"),
    // ElementUI的国际化语言, 以el.开头
    ...zhLocale
  }
};
const i18n = new VueI18n({
  locale: localStorage.lang || "zh", // 默认语言标识
  messages
});
Vue.use(ElementUI, {size: "small",i18n: (key, value) => i18n.t(key, value) });

// moment默认设置
moment.locale("en", {
  longDateFormat: {
    l: "YYYY-MM-DD",
    ll: "YYYY-MM-DD HH:mm",
    L: "YYYY-MM-DD HH:mm:ss",
    LT: "HH:mm",
    LTS: "HH:mm:ss"
  }
});
/**
 * 注册一个自定义指令，防止按钮连击
 */
Vue.directive("preventClick", {
  inserted(el) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, 2000);
      }
    });
  }
});

/**
 * 日期时间格式化全局过滤器, 默认pattern = 'L'
 * 使用示例：
 * <span>发表时间：{{ newsinfo.addTime | dateFormat()}}</span>
 * <span>发表时间：{{ newsinfo.addTime | dateFormat('YYYY-MM-DD HH:mm:ss')}}</span>
 * <span>出生日期：{{ person.birthdate | dateFormat('YYYY-MM-DD')}}</span>
 * <span v-if="scope.row.operateTime">{{ scope.row.operateTime | dateFormat() }}</span>
 * @param {Long/Date} timestamp 时间戳，支持长整型(毫秒)和日期型
 * @param {String} pattern 日期格式简写或具体日期格式，默认为L
 *    简写有效值域[l, ll, L, LTS, LT]以及其他moment支持的简写
 *    l: 'YYYY-MM-DD'
 *    ll: 'YYYY-MM-DD HH:mm'
 *    L: 'YYYY-MM-DD HH:mm:ss'
 *    LTS: 'HH:mm:ss'
 *    LT: 'HH:mm'
 *    更多pattern请查看http://momentjs.cn/
 */
Vue.filter("dateFormat", function(timestamp, pattern = "L") {
  return moment(timestamp).format(pattern);
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
